module.exports = __webpack_public_path__ + "static/media/schody-do-kaple.9149d909.jpg";